"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsperaPlugin = exports.isUnderRecommendedVersion = exports.isRecommendedVersionOrHigher = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-unused-vars, @typescript-eslint/no-var-requires, no-underscore-dangle */
/* Package Imports */
var connect_sdk_js_1 = require("@ibm-aspera/connect-sdk-js");
var http_gateway_sdk_js_1 = require("@ibm-aspera/http-gateway-sdk-js");
var moment_1 = __importDefault(require("moment"));
var react_1 = require("react");
var react_device_detect_1 = require("react-device-detect");
var react_redux_1 = require("react-redux");
var semver_1 = __importDefault(require("semver"));
/* Blast Imports */
var eventManager_1 = require("../eventManager");
var pluginActions_1 = require("../pluginActions");
var selectors_1 = require("../state/selectors");
var _state_1 = __importDefault(require("@app/_state"));
var models_1 = require("@app/_state/models");
var actions_1 = require("@app/features/new-packages/state/actions");
var actions_2 = require("@app/features/package-files/state/actions");
var actions_3 = require("@app/features/pending-uploads/state/actions");
var actions_4 = require("@app/features/transfers/state/actions");
var actions_5 = require("@app/features/ui/state/actions");
var actions_6 = require("@app/features/users/state/actions");
var config_1 = require("@app/shared/config");
var constants_1 = require("@app/shared/constants");
var log_1 = __importDefault(require("@app/shared/log"));
var matomo_1 = require("@app/shared/matomo");
var utils_1 = require("@app/shared/utils");
var api_1 = require("@server/types/api");
var initialState = {
    connectVersion: '',
    gatewayUploadCount: 0
};
var ComponentName = 'AsperaPlugin';
/* Utility Functions - begin */
var isRecommendedVersionOrHigher = function (asperaVersion, recommendedVersion) {
    var cleanedVersion = semver_1.default.coerce(asperaVersion);
    if (!cleanedVersion) {
        return false;
    }
    return semver_1.default.satisfies(cleanedVersion, ">=" + recommendedVersion);
};
exports.isRecommendedVersionOrHigher = isRecommendedVersionOrHigher;
var isUnderRecommendedVersion = function (asperaVersion, recommendedVersion) {
    var cleanedVersion = semver_1.default.coerce(asperaVersion);
    if (!cleanedVersion) {
        return false;
    }
    return semver_1.default.lt(cleanedVersion, recommendedVersion);
};
exports.isUnderRecommendedVersion = isUnderRecommendedVersion;
/* Utility Functions - end */
/**
 * Component to interact with and handle events from the Aspera Connect plugin
 */
var AsperaPlugin = /** @class */ (function (_super) {
    __extends(AsperaPlugin, _super);
    function AsperaPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.HttpGatewayCallbackId = '';
        /* Component Lifecycle Methods - end */
        /* Component Methods - Begin */
        /* Aspera Extension Functions - begin */
        _this.checkExtension = function () {
            if (_this.asperaInstaller.doesBrowserNeedExtensionStore()) {
                _this.asperaInstaller.isExtensionInstalled(500, {
                    success: function () {
                        log_1.default.info('extension is installed');
                        _this.startPluginless(true);
                    },
                    timedout: function () {
                        log_1.default.info('extension is not installed');
                        _this.props.onStatus(connect_sdk_js_1.Connect.STATUS.FAILED);
                        _this.asperaInstaller.dismiss();
                        _this.startPluginless(false);
                    }
                });
            }
            else {
                _this.props.onStatus(connect_sdk_js_1.Connect.STATUS.FAILED);
                _this.asperaInstaller.dismiss();
                // Doesn't use extension, set extension status as true
                _this.startPluginless(true);
            }
        };
        /* Aspera Extension Functions - begin */
        /* Aspera Connect Functions - begin */
        _this.getVersion = function () {
            if (connect_sdk_js_1.Connect.STATUS && _this.asperaWeb.getStatus() === connect_sdk_js_1.Connect.STATUS.RUNNING) {
                _this.asperaWeb.version({
                    success: function (version) {
                        var state = _state_1.default.getState();
                        if (state.transfers.connectVersion !== version.version) {
                            var connectVersion = version.version ? version.version : constants_1.NOT_APPLICABLE;
                            _this.matomo.trackEvent('Aspera Plugin', 'Version', connectVersion);
                            _this.setState(__assign(__assign({}, _this.state), { connectVersion: connectVersion }));
                        }
                        if (!version.version || exports.isUnderRecommendedVersion(version.version, constants_1.ASPERA_PLUGIN_MIN_VERSION)) {
                            _this.props.onStatus(connect_sdk_js_1.Connect.STATUS.FAILED);
                            if (version.version) {
                                _this.props.onSetVersion(version.version);
                            }
                            _this.startPluginless(true);
                        }
                        else {
                            _this.props.onSetVersion(version.version);
                            if (exports.isUnderRecommendedVersion(version.version, constants_1.ASPERA_PLUGIN_RECOMMENDED_VERSION)) {
                                _this.props.onDisplayAsperaVersionBanner();
                            }
                        }
                    },
                    error: function (error) {
                        log_1.default.error("No version of Aspera plugin was found");
                        _this.props.onStatus(connect_sdk_js_1.Connect.STATUS.FAILED);
                    }
                });
            }
            else {
                setTimeout(function () {
                    _this.matomo.trackEvent('Aspera Plugin', 'Version', constants_1.NOT_APPLICABLE);
                }, 200);
            }
        };
        _this.handleAttachDragAndDrop = function (args) {
            var targetElementSelector = args[0];
            _this.asperaWeb.setDragDropTargets(targetElementSelector, {
                dragEnter: true,
                dragLeave: true,
                dragOver: true,
                drop: true
            }, function (dragDropObject) {
                if (dragDropObject.event.type === 'dragenter') {
                    _this.props.onDragStatusChange(true);
                }
                if (dragDropObject.event.type === 'dragleave') {
                    _this.props.onDragStatusChange(false);
                }
                if (dragDropObject.event.type === 'dragover') {
                    if (!_this.props.isUploadDragActive) {
                        _this.props.onDragStatusChange(true);
                    }
                }
                if (dragDropObject.event.type === 'drop') {
                    _this.props.onDragStatusChange(false);
                    _this.selectFiles(dragDropObject.files);
                }
            });
            _this.matomo.trackEvent('Aspera Plugin', 'Attach Drag And Drop Files');
        };
        _this.handleGetAllTransfers = function () {
            _this.asperaWeb.getAllTransfers({
                success: function (data) { return _this.updateTransfers(data); }
            });
        };
        _this.handleRemoveTransfer = function (transferId, transferType) {
            _this.asperaWeb.removeTransfer(transferId, {
                success: function () {
                    log_1.default.info("Removed " + transferType + " Aspera transfer with ID " + transferId);
                },
                error: function (error) {
                    log_1.default.error("Unable to remove " + transferType + " Aspera transfer with ID " + transferId + ": " + JSON.stringify(error));
                }
            });
        };
        _this.handleResumeTransfer = function (args) {
            var transferId = args[0];
            _this.asperaWeb.resumeTransfer(transferId, {}, {
                success: function () {
                    log_1.default.info("Resumed transfer with ID " + transferId);
                    _this.matomo.trackEvent('Aspera Plugin', 'Resume Transfer');
                },
                error: function (error) {
                    log_1.default.error("Unable to resume transfer with ID " + transferId + ": " + JSON.stringify(error));
                    _this.matomo.trackEvent('Aspera Plugin', 'Resume Transfer', 'Failed');
                }
            });
        };
        _this.handleShowDirectory = function (args) {
            var transferId = args[0];
            _this.asperaWeb.showDirectory(transferId, {}, {
                success: function () {
                    log_1.default.info("Show directory of transfer with ID " + transferId);
                    _this.matomo.trackEvent('Aspera Plugin', 'Show Directory');
                },
                error: function (error) {
                    log_1.default.error("Unable to show directory of transfer with ID " + transferId + ": " + JSON.stringify(error));
                    _this.matomo.trackEvent('Aspera Plugin', 'Show Directory', 'Failed');
                }
            });
        };
        /**
         * Display file selection menu
         */
        _this.handleShowSelectFileDialog = function () {
            var dialogOptions = {
                allowMultipleSelection: true
            };
            _this.asperaWeb.showSelectFileDialog({
                success: function (args) {
                    _this.selectFiles(args);
                    _this.matomo.trackEvent('Aspera Plugin', 'Show Select Files Dialog Window');
                }
            }, dialogOptions);
        };
        /**
         * Display folder selection menu
         */
        _this.handleShowSelectFolderDialog = function () {
            _this.asperaWeb.showSelectFolderDialog({
                success: function (args) {
                    _this.selectFiles(args);
                    _this.matomo.trackEvent('Aspera Plugin', 'Show Select Folder Dialog Window');
                }
            });
        };
        _this.handleShowPreferences = function () {
            _this.asperaWeb.showPreferences({
                success: function (args) {
                    log_1.default.info("Show Aspera preferences");
                }
            });
        };
        _this.handleShowTransferManagerWindow = function () {
            _this.asperaWeb.showTransferManager({
                success: function (args) {
                    log_1.default.info("Show transfer manager");
                }
            });
        };
        _this.handleStartAspera = function () {
            _this.asperaWeb.start();
            _this.matomo.trackEvent('Aspera Plugin', 'Start Aspera');
        };
        _this.handleStartTransfer = function (args) {
            var transferSpec = args[0];
            var packageId = args[1];
            var packageTitle = args[2];
            var direction = transferSpec.direction;
            var isPackage = transferSpec.paths[0].source.endsWith('/');
            var connectSettings = {
                // Only show aspera dialog if encrypting on upload or decrypting on download
                allow_dialogs: transferSpec.content_protection === 'encrypt' || transferSpec.content_protection === 'decrypt'
            };
            var response = _this.asperaWeb.startTransfer(transferSpec, connectSettings, {
                success: function () {
                    _this.props.onTransferStarted(response.request_id, packageId, direction, packageTitle);
                    if (direction === api_1.Direction.SEND) {
                        _this.props.onUploadSuccess();
                        _this.matomo.trackEvent('Aspera Plugin', 'Start Transfer', (transferSpec.content_protection === 'encrypt' ? 'Encrypted' : '') + " Upload");
                    }
                    else {
                        _this.matomo.trackEvent('Aspera Plugin', 'Start Transfer', (transferSpec.content_protection === 'decrypt' ? 'Encrypted' : '') + " Download");
                    }
                },
                error: function () {
                    _this.props.onTransferReject(response.request_id, packageId, (!isPackage) ? transferSpec.paths[0].source.substring(transferSpec.paths[0].source.lastIndexOf('/')) : '');
                    _this.matomo.trackEvent('Aspera Plugin', 'Start Transfer', 'Failed');
                }
            });
        };
        _this.handleStopAspera = function () {
            var timeout = (_this.asperaWeb.getStatus() === 'RUNNING') ? 500 : 2500;
            setTimeout(function () {
                _this.asperaWeb.stop();
            }, timeout);
            _this.matomo.trackEvent('Aspera Plugin', 'Stop Aspera');
            _this.asperaWeb.removeEventListener(connect_sdk_js_1.Connect.EVENT.TRANSFER);
        };
        _this.handleStopTransfer = function (args) {
            var transferId = args[0];
            _this.asperaWeb.stopTransfer(transferId, {
                success: function () {
                    log_1.default.info("Stopped transfer with ID " + transferId);
                    _this.matomo.trackEvent('Aspera Plugin', 'Stop Transfer');
                },
                error: function (error) {
                    log_1.default.error("Unable to stop transfer with ID " + transferId + ": " + JSON.stringify(error));
                    _this.matomo.trackEvent('Aspera Plugin', 'Stop Transfer', 'Failed');
                }
            });
        };
        _this.updateTransfers = function (data) {
            var state = _state_1.default.getState();
            if (data.transfers.length > 0) {
                data.transfers = _this.filterCurrentUsersTransfers(data.transfers);
                data.transfers = _this.filterOldTransfers(data.transfers);
                if (data.transfers.length > 1) {
                    log_1.default.debug("# of transfers from plugin: " + data.transfers.length);
                }
                data.transfers.forEach(function (t) {
                    var totalSize = t.bytes_expected;
                    var transferredBytes = t.files ?
                        t.files.map(function (f) { return f.bytes_written; }).reduce(function (prev, next) { return Number(prev) + Number(next); }, 0) :
                        t.bytes_written;
                    var createdAt = t.transfer_spec.tags.aspera.faspex.metadata._created_utc;
                    createdAt = moment_1.default(new Date(createdAt)).format();
                    var modifyTime = moment_1.default(new Date(t.modify_time)).format();
                    var direction = t.transfer_spec.direction;
                    var transferTitle = t.title;
                    var packageTitle = t.transfer_spec.tags.aspera.faspex.metadata._pkg_name;
                    var requestId = t.aspera_connect_settings.request_id;
                    var transferId = t.uuid;
                    var packageId = selectors_1.getPackageIdForActiveXfer(state, requestId) || t.transfer_spec.tags.aspera.faspex.metadata._pkg_id;
                    var packageState = _this.mapTransferStateToPackageState(t.status);
                    if (!packageTitle || !createdAt) {
                        log_1.default.warn("Package title or creation date missing: Updating transfer: Title: '" + packageTitle + "'. CreationDate: " + createdAt + ". Pkg size: " + totalSize + ". TransferredBytes: " + transferredBytes + ". State: " + packageState, ComponentName);
                    }
                    var isFullPackage = transferTitle.startsWith("PKG - ");
                    var isFolder = (t.files && t.files.length > 1);
                    var errorCode = t.error_code;
                    var errorDesc = t.error_desc;
                    _this.props.onStoreTransfer(direction, packageTitle, transferTitle, totalSize, transferredBytes, createdAt, modifyTime, packageState, packageId, transferId, isFullPackage, errorCode, errorDesc);
                    _this.props.onUpdateTransfer(direction, packageTitle, totalSize, transferredBytes, createdAt, packageState, transferId, packageId, isFullPackage, errorCode, errorDesc, true);
                    var isPackageTransferComplete = packageState === models_1.PackageTransferState.COMPLETE;
                    var isPackageTransferCompleteRemoved = packageState === models_1.PackageTransferState.REMOVED && totalSize === transferredBytes;
                    var isPackageTransferFailed = packageState === models_1.PackageTransferState.FAILED;
                    if (direction === api_1.Direction.RECEIVE) {
                        _this.props.onUpdateFileTransfer(!isFullPackage && !isFolder && t.transfer_spec.content_protection === 'decrypt' ? transferTitle + ".aspera-env" : transferTitle, packageTitle, createdAt, totalSize, transferredBytes, packageState, transferId, isFullPackage, errorCode, errorDesc);
                        if (isPackageTransferComplete || isPackageTransferCompleteRemoved) {
                            _this.props.onArchivePackage(packageTitle, createdAt, requestId);
                        }
                    }
                    if (isPackageTransferFailed) {
                        _this.matomo.trackEvent('Aspera Plugin', 'Failed Transfer', errorCode + ": " + errorDesc);
                    }
                    if (isPackageTransferComplete || isPackageTransferCompleteRemoved) {
                        _this.props.onTransferCompleted(requestId, direction);
                    }
                });
            }
        };
        /* Aspera Connect Functions - end */
        /* HTTP Gateway Functions - begin */
        _this.checkHttpGatewayReadyStatus = function () {
            var status = http_gateway_sdk_js_1.asperaHttpGateway.isReady;
            log_1.default.debug("Is gateway ready: + " + status);
            return status;
        };
        _this.handleDropForUpload = function (args) {
            var formId = "blast-upload-" + _this.state.gatewayUploadCount;
            var targetElementSelector = args[0];
            var fileDropCallback = function (files) {
                _this.selectFiles(files.files);
            };
            http_gateway_sdk_js_1.asperaHttpGateway.createDropzone(fileDropCallback, targetElementSelector, formId);
        };
        _this.handleSelectFilesForUpload = function () {
            var formId = "blast-upload-" + _this.state.gatewayUploadCount;
            var files_for_spec = [];
            var filePickCallback = function (files) {
                for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
                    var file = files_1[_i];
                    files_for_spec.push(file);
                }
                _this.selectFiles(files);
            };
            http_gateway_sdk_js_1.asperaHttpGateway.getFilesForUpload(filePickCallback, formId);
        };
        _this.handleStartHttpGatewayDownload = function (args) { return __awaiter(_this, void 0, void 0, function () {
            var transferSpec, pkg, packageId, packageTitle, file, direction, isFullPackage, totalSize, transferTitle, sourceFolders, createdAt, asperaGatewayHost;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        transferSpec = args[0];
                        transferSpec.zip_required = false;
                        pkg = args[1];
                        packageId = pkg.id;
                        packageTitle = pkg.title || transferSpec.tags.aspera.faspex.metadata._pkg_name;
                        file = args[2];
                        direction = transferSpec.direction;
                        isFullPackage = transferSpec.paths[0].source.endsWith('/') && !file;
                        totalSize = (isFullPackage) ? pkg.totalBytes : file.size;
                        transferTitle = (isFullPackage) ? "PKG - " + packageTitle : file.name;
                        this.props.onGatewayTransferStarted(isFullPackage ? packageId : packageId + "-" + file.name, packageId, direction, packageTitle);
                        if (!isFullPackage) {
                            if (!file.isLeaf) {
                                sourceFolders = transferSpec.paths[0].source.split('/');
                                transferSpec.download_name = (sourceFolders[sourceFolders.length - 1] + " from PKG - " + packageTitle).replace(/[/:*?"<>|\\]/g, '_');
                                transferSpec.zip_required = true;
                            }
                            else {
                                transferSpec.source_root = transferSpec.paths[0].source.replace(file.name, '');
                                transferSpec.paths[0].source = file.name;
                            }
                        }
                        else {
                            transferSpec.download_name = ("" + transferTitle).replace(/[/:*?"<>|\\]/g, '_');
                            transferSpec.zip_required = true;
                        }
                        createdAt = transferSpec.tags.aspera.faspex.metadata._created_utc;
                        createdAt = moment_1.default(new Date(createdAt)).format();
                        // Set transfer as in progress
                        // onStoreTransfer
                        this.props.onStoreTransfer(direction, packageTitle, transferTitle, totalSize, 0, createdAt, moment_1.default(new Date()).format(), models_1.PackageTransferState.IN_PROGRESS, packageId, '', isFullPackage);
                        // onUpdateTransfer
                        this.props.onUpdateTransfer(direction, packageTitle, totalSize, 0, createdAt, models_1.PackageTransferState.IN_PROGRESS, '', packageId, isFullPackage, undefined, undefined, false);
                        if (!isFullPackage) {
                            // onUpdateFileTransfer
                            this.props.onUpdateFileTransfer(transferTitle, packageTitle, createdAt, totalSize, 0, models_1.PackageTransferState.IN_PROGRESS, '', isFullPackage);
                        }
                        asperaGatewayHost = http_gateway_sdk_js_1.asperaHttpGateway.globals.serverUrl.replace('https://', '').replace(constants_1.HTTP_GATEWAY_ENDPOINT, '');
                        if (!(transferSpec.gateway_host && !transferSpec.gateway_host.includes(asperaGatewayHost))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.resetupHttpGateway(utils_1.pickRandomValueFromArray(transferSpec.gateway_host))];
                    case 1:
                        if (!(_a.sent())) {
                            log_1.default.debug('Gateway reset unsuccessful');
                            this.matomo.trackEvent('Aspera HTTP Gateway', 'Start Transfer', 'Gateway Reset Failed');
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        log_1.default.debug('Gateway reset not needed');
                        _a.label = 3;
                    case 3:
                        log_1.default.debug("HTTP Gateway download starting, connecting to " + http_gateway_sdk_js_1.asperaHttpGateway.globals.serverUrl);
                        http_gateway_sdk_js_1.asperaHttpGateway.download(transferSpec).then(function (response) {
                            log_1.default.debug("HTTP Gateway Download started: " + JSON.stringify(response));
                            setTimeout(function () {
                                // onStoreTransfer
                                _this.props.onStoreTransfer(direction, packageTitle, transferTitle, totalSize, totalSize, createdAt, moment_1.default(new Date()).format(), models_1.PackageTransferState.COMPLETE, packageId, '', isFullPackage);
                                // onUpdateTransfer
                                _this.props.onUpdateTransfer(direction, packageTitle, totalSize, totalSize, createdAt, models_1.PackageTransferState.COMPLETE, '', packageId, isFullPackage, undefined, undefined, false);
                                if (!isFullPackage) {
                                    // onUpdateFileTransfer
                                    _this.props.onUpdateFileTransfer(transferTitle, packageTitle, createdAt, totalSize, totalSize, models_1.PackageTransferState.COMPLETE, '', isFullPackage);
                                }
                                // onArchivePackage
                                _this.props.onArchiveKnownPackage(packageId, pkg);
                                // onTransferCompleted
                                _this.props.onGatewayTransferCompleted(isFullPackage ? packageId : packageId + "-" + file.name, direction);
                            }, constants_1.GATEWAY_DOWNLOAD_TIMEOUT);
                            _this.matomo.trackEvent('Aspera HTTP Gateway', 'Start Transfer', "Download");
                        }).catch(function (error) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        log_1.default.debug("HTTP Gateway Download could not start: " + JSON.stringify(error));
                                        return [4 /*yield*/, this.updateGatewayStatus(false)];
                                    case 1:
                                        _a.sent();
                                        this.matomo.trackEvent('Aspera HTTP Gateway', 'Start Transfer', 'Failed');
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        }); };
        /* HTTP Gateway Upload - not in use, will need to be refined */
        _this.handleStartHttpGatewayUpload = function (args) { return __awaiter(_this, void 0, void 0, function () {
            var transferSpec, _i, _a, file, packageId, packageTitle, formId, direction, isPackage, asperaGatewayHost;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        transferSpec = args[0];
                        for (_i = 0, _a = transferSpec.paths; _i < _a.length; _i++) {
                            file = _a[_i];
                            file.destination = file.source;
                        }
                        packageId = args[1];
                        packageTitle = args[2];
                        formId = "blast-upload-" + this.state.gatewayUploadCount;
                        direction = transferSpec.direction;
                        isPackage = transferSpec.paths[0].source.endsWith('/');
                        asperaGatewayHost = http_gateway_sdk_js_1.asperaHttpGateway.globals.serverUrl.replace('https://', '').replace(constants_1.HTTP_GATEWAY_ENDPOINT, '');
                        if (!(transferSpec.gateway_host && !transferSpec.gateway_host.includes(asperaGatewayHost))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.resetupHttpGateway(utils_1.pickRandomValueFromArray(transferSpec.gateway_host))];
                    case 1:
                        if (!(_b.sent())) {
                            log_1.default.debug('Gateway reset unsuccessful');
                            this.matomo.trackEvent('Aspera HTTP Gateway', 'Start Transfer', 'Gateway Reset Failed');
                            this.props.onGatewayTransferReject(packageId, packageId, (!isPackage) ? transferSpec.paths[0].source.substring(transferSpec.paths[0].source.lastIndexOf('/')) : '');
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        log_1.default.debug('Gateway reset not needed');
                        _b.label = 3;
                    case 3:
                        http_gateway_sdk_js_1.asperaHttpGateway.upload(transferSpec, formId).then(function (response) {
                            log_1.default.debug("HTTP Gateway Upload started: " + JSON.stringify(response));
                            _this.props.onGatewayTransferStarted(packageId, packageId, direction, packageTitle);
                            _this.matomo.trackEvent('Aspera HTTP Gateway', 'Start Transfer', "Upload");
                            _this.setState(__assign(__assign({}, _this.state), { gatewayUploadCount: (_this.state.gatewayUploadCount + 1) }));
                        }).catch(function (error) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        log_1.default.debug("HTTP Gateway Upload could not start: " + JSON.stringify(error));
                                        return [4 /*yield*/, this.updateGatewayStatus(false)];
                                    case 1:
                                        _a.sent();
                                        this.props.onGatewayTransferReject(packageId, packageId, (!isPackage) ? transferSpec.paths[0].source.substring(transferSpec.paths[0].source.lastIndexOf('/')) : '');
                                        this.matomo.trackEvent('Aspera HTTP Gateway', 'Start Transfer', 'Upload Failed');
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.monitorHttpGatewayTransfers = function (data) {
            // Log.debug(`Monitoring HTTP Gateway transfers - ${data.transfers.length} transfers being monitored`);
            _this.updateUploadTransfers(data);
        };
        _this.resetupHttpGateway = function (host) { return __awaiter(_this, void 0, void 0, function () {
            var httpGatewaySuccessful;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log_1.default.debug("Attempting to reset HTTP Gateway to new host: " + host);
                        httpGatewaySuccessful = false;
                        // Initialize Http Gateway - dev value: 'https://test-aspera-p-ri.hasbro.com/aspera/http-gwy/v1'
                        return [4 /*yield*/, http_gateway_sdk_js_1.asperaHttpGateway.initHttpGateway("https://" + host + constants_1.HTTP_GATEWAY_ENDPOINT).then(function (response) {
                                httpGatewaySuccessful = true;
                                log_1.default.debug("HTTP Gateway SDK restarted: " + JSON.stringify(response));
                            }).catch(function (error) {
                                httpGatewaySuccessful = false;
                                // Handle app logic to indicate transfers are not available
                                log_1.default.debug("HTTP Gateway SDK did not restart: " + JSON.stringify(error));
                            })];
                    case 1:
                        // Initialize Http Gateway - dev value: 'https://test-aspera-p-ri.hasbro.com/aspera/http-gwy/v1'
                        _a.sent();
                        return [4 /*yield*/, this.updateGatewayStatus(false)];
                    case 2:
                        httpGatewaySuccessful = _a.sent();
                        return [2 /*return*/, httpGatewaySuccessful];
                }
            });
        }); };
        _this.setupHttpGateway = function () { return __awaiter(_this, void 0, void 0, function () {
            var httpGatewaySuccessful;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpGatewaySuccessful = false;
                        // Initialize Http Gateway - dev value: 'https://test-aspera-p-ri.hasbro.com/aspera/http-gwy/v1'
                        return [4 /*yield*/, http_gateway_sdk_js_1.asperaHttpGateway.initHttpGateway("https://" + utils_1.pickRandomValueFromArray(this.props.gatewayHost) + constants_1.HTTP_GATEWAY_ENDPOINT).then(function (response) {
                                httpGatewaySuccessful = true;
                                log_1.default.debug("HTTP Gateway SDK started: " + JSON.stringify(response));
                            }).catch(function (error) {
                                httpGatewaySuccessful = false;
                                // Handle app logic to indicate transfers are not available
                                log_1.default.debug("HTTP Gateway SDK did not start: " + JSON.stringify(error));
                            })];
                    case 1:
                        // Initialize Http Gateway - dev value: 'https://test-aspera-p-ri.hasbro.com/aspera/http-gwy/v1'
                        _a.sent();
                        if (!httpGatewaySuccessful) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.updateGatewayStatus(true)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.props.onHttpGatewayStatus(httpGatewaySuccessful);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.shutdownHttpGateway = function () {
            http_gateway_sdk_js_1.asperaHttpGateway.deregisterActivityCallback(_this.HttpGatewayCallbackId);
        };
        _this.testHttpGatewayConnection = function () { return __awaiter(_this, void 0, void 0, function () {
            var testSuccessful;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        testSuccessful = false;
                        // Test Http Gateway
                        return [4 /*yield*/, http_gateway_sdk_js_1.asperaHttpGateway.testHttpGatewayConnection().then(function (response) {
                                log_1.default.debug("HTTP Gateway server is up and working: " + JSON.stringify(response));
                                testSuccessful = true;
                            }).catch(function (error) {
                                log_1.default.debug("HTTP Gateway server is no longer available: " + JSON.stringify(error));
                                testSuccessful = false;
                            })];
                    case 1:
                        // Test Http Gateway
                        _a.sent();
                        return [2 /*return*/, testSuccessful];
                }
            });
        }); };
        _this.updateGatewayStatus = function (registerActivityCallback) { return __awaiter(_this, void 0, void 0, function () {
            var httpGatewaySuccessful;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.testHttpGatewayConnection()];
                    case 1:
                        httpGatewaySuccessful = _a.sent();
                        if (httpGatewaySuccessful) {
                            httpGatewaySuccessful = this.checkHttpGatewayReadyStatus();
                            if (registerActivityCallback) {
                                this.HttpGatewayCallbackId = http_gateway_sdk_js_1.asperaHttpGateway.registerActivityCallback(this.monitorHttpGatewayTransfers);
                            }
                        }
                        else {
                            this.shutdownHttpGateway();
                        }
                        this.props.onHttpGatewayStatus(httpGatewaySuccessful);
                        return [2 /*return*/, httpGatewaySuccessful];
                }
            });
        }); };
        _this.updateUploadTransfers = function (data) {
            var state = _state_1.default.getState();
            if (data.transfers.length > 0) {
                data.transfers = _this.filterCurrentUsersTransfers(data.transfers);
                data.transfers = _this.filterOldTransfers(data.transfers);
                if (data.transfers.length > 1) {
                    log_1.default.debug("# of transfers from plugin: " + data.transfers.length);
                }
                data.transfers.forEach(function (t) {
                    var totalSize = t.bytes_expected;
                    var transferredBytes = t.bytes_written;
                    var createdAt = t.transfer_spec.tags.aspera.faspex.metadata._created_utc;
                    createdAt = moment_1.default(new Date(createdAt)).format();
                    var modifyTime = moment_1.default(new Date(t.modify_time)).format();
                    var direction = t.transfer_spec.direction;
                    var transferTitle = t.title || t.transfer_spec.tags.aspera.faspex.metadata._pkg_name;
                    var packageTitle = t.transfer_spec.tags.aspera.faspex.metadata._pkg_name;
                    var requestId = t.transfer_spec.tags.aspera.faspex.metadata._pkg_id;
                    var transferId = t.uuid;
                    var packageId = selectors_1.getPackageIdForActiveXfer(state, requestId) || t.transfer_spec.tags.aspera.faspex.metadata._pkg_id;
                    var packageState = _this.mapTransferStateToPackageState(t.status);
                    if (!packageTitle || !createdAt) {
                        log_1.default.warn("Package title or creation date missing: Updating transfer: Title: '" + packageTitle + "'. CreationDate: " + createdAt + ". Pkg size: " + totalSize + ". TransferredBytes: " + transferredBytes + ". State: " + packageState, ComponentName);
                    }
                    var isFullPackage = transferTitle.startsWith("PKG - ");
                    _this.props.onStoreTransfer(direction, packageTitle, transferTitle, totalSize, transferredBytes, createdAt, modifyTime, packageState, packageId, transferId, isFullPackage);
                    _this.props.onUpdateTransfer(direction, packageTitle, totalSize, transferredBytes, createdAt, packageState, transferId, packageId, isFullPackage, undefined, undefined, false);
                    var isPackageTransferComplete = packageState === models_1.PackageTransferState.COMPLETE;
                    var isPackageTransferCompleteRemoved = packageState === models_1.PackageTransferState.REMOVED && totalSize === transferredBytes;
                    var isPackageTransferFailed = packageState === models_1.PackageTransferState.FAILED || packageState === models_1.PackageTransferState.STOPPED;
                    if (isPackageTransferComplete || isPackageTransferCompleteRemoved) {
                        _this.props.onGatewayTransferCompleted(requestId, direction);
                        http_gateway_sdk_js_1.asperaHttpGateway.removeTransfer(t.uuid);
                    }
                    if (isPackageTransferFailed) {
                        _this.props.onGatewayTransferFailed(packageId, packageId, '');
                        http_gateway_sdk_js_1.asperaHttpGateway.removeTransfer(t.uuid);
                    }
                });
            }
        };
        /* HTTP Gateway Functions - end */
        /* Plugin-less Functions - begin */
        /**
         * When Aspera Connect plugin can't be used, transfers will be attempted using either
         * HTTP Gateway or our fallback Plugin-less
         */
        _this.startPluginless = function (extensionStatus, displayInstall) {
            if (displayInstall === void 0) { displayInstall = true; }
            if (displayInstall) {
                _this.props.onDisplayAsperaInstall(extensionStatus, _this.asperaInstaller.getExtensionStoreLink());
            }
            _this.props.onGetHttpTransfers();
        };
        /* Plugin-less Functions - end */
        /* Utility Functions - begin */
        /**
         * Check if a transfer should be removed, due to expiration or failure, from the Aspera plugin
         */
        _this.checkIfTransferHasExpired = function (t) {
            var state = _state_1.default.getState();
            var asperaPluginTransferLimit = state.dash.asperaPluginTransferLimit ? state.dash.asperaPluginTransferLimit : config_1.Config.PACKAGE_EXPIRE_LIMIT_IN_DAYS;
            var expiredTransferDate = moment_1.default().subtract(asperaPluginTransferLimit, 'days');
            if (moment_1.default(t.modify_time).isBefore(expiredTransferDate)) {
                _this.handleRemoveTransfer(t.uuid, 'expired');
            }
            else {
                var packageState = _this.mapTransferStateToPackageState(t.status);
                if (packageState === models_1.PackageTransferState.FAILED) {
                    _this.handleRemoveTransfer(t.uuid, 'failed');
                }
            }
        };
        /**
         * Filter transfers for the currently logged-in user
         */
        _this.filterCurrentUsersTransfers = function (transfers) {
            return transfers.filter(function (t) {
                if (t.transfer_spec.direction === api_1.Direction.SEND) {
                    return t.transfer_spec.tags.aspera.faspex.requestor.name === _this.props.userEmail;
                }
                else {
                    return t.transfer_spec.tags.aspera.faspex.downloader.name === _this.props.userEmail;
                }
            });
        };
        /**
         * Filter out sent packages older than 48 hours
         */
        _this.filterOldTransfers = function (transfers) {
            var minReceivedDate = moment_1.default().subtract(config_1.Config.RECEIVED_PACKAGES_HISTORY_LIMIT_IN_HOURS, 'hours');
            var minSentDate = moment_1.default().subtract(config_1.Config.PENDING_PACKAGES_HISTORY_LIMIT_IN_HOURS, 'hours');
            return transfers.filter(function (t) {
                if (t.transfer_spec.direction !== api_1.Direction.SEND) {
                    if (moment_1.default(t.modify_time).isAfter(minReceivedDate)) {
                        return true;
                    }
                    else {
                        _this.checkIfTransferHasExpired(t);
                        return false;
                    }
                }
                if (moment_1.default(t.modify_time).isAfter(minSentDate)) {
                    return true;
                }
                else {
                    _this.checkIfTransferHasExpired(t);
                    return false;
                }
            });
        };
        _this.mapTransferStateToPackageState = function (transferState) {
            switch (transferState) {
                case connect_sdk_js_1.Connect.TRANSFER_STATUS.INITIATING:
                case connect_sdk_js_1.Connect.TRANSFER_STATUS.RUNNING:
                    return models_1.PackageTransferState.IN_PROGRESS;
                case connect_sdk_js_1.Connect.TRANSFER_STATUS.COMPLETED:
                    return models_1.PackageTransferState.COMPLETE;
                case connect_sdk_js_1.Connect.TRANSFER_STATUS.WILLRETRY:
                    return models_1.PackageTransferState.WILLRETRY;
                case connect_sdk_js_1.Connect.TRANSFER_STATUS.CANCELLED:
                    return models_1.PackageTransferState.STOPPED;
                case connect_sdk_js_1.Connect.TRANSFER_STATUS.QUEUED:
                    return models_1.PackageTransferState.QUEUED;
                case connect_sdk_js_1.Connect.TRANSFER_STATUS.REMOVED:
                    return models_1.PackageTransferState.REMOVED;
                default:
                    return models_1.PackageTransferState.FAILED;
            }
        };
        _this.selectFiles = function (args) {
            var files = args.dataTransfer.files.map(function (f) {
                return {
                    filename: (react_device_detect_1.osName.startsWith('Windows')) ? f.name.split('\\').pop() : f.name.split('/').pop(),
                    path: f.name,
                    size: f.size,
                    type: f.type // folders will have a type of "inode/directory"
                };
            });
            if (files.length > 0) {
                _this.props.onAddToast(actions_5.ToastType.FILE_SELECT_ADDED_FILES, 'File(s) Added');
            }
            _this.props.onSelect(files);
        };
        return _this;
    }
    /* Component Lifecycle Methods - begin */
    AsperaPlugin.prototype.componentDidMount = function () {
        var _this = this;
        log_1.default.debug("GATEWAY HOST: " + (this.props.gatewayHost ? this.props.gatewayHost.toString() : ''));
        this.matomo = new matomo_1.MatomoTracker();
        this.asperaWeb = new connect_sdk_js_1.Connect({ sdkLocation: constants_1.ASPERA_SDK_LOCATION, dragDropEnabled: true, minVersion: '3.9.0' });
        this.asperaInstaller = new connect_sdk_js_1.ConnectInstaller({ sdkLocation: constants_1.ASPERA_SDK_LOCATION, iframeId: 'asperaIframe' });
        this.asperaInstaller.supportsInstallingExtensions = true;
        // Event listeners
        eventManager_1.eventManager.on(pluginActions_1.ATTACH_DRAG_AND_DROP, this.handleAttachDragAndDrop);
        eventManager_1.eventManager.on(pluginActions_1.DROP_FILES_FOR_UPLOAD, this.handleDropForUpload);
        eventManager_1.eventManager.on(pluginActions_1.SELECT_FILES_FOR_UPLOAD, this.handleSelectFilesForUpload);
        eventManager_1.eventManager.on(pluginActions_1.SHOW_PREFERENCES, this.handleShowPreferences);
        eventManager_1.eventManager.on(pluginActions_1.SHOW_SELECT_FILE_DIALOG, this.handleShowSelectFileDialog);
        eventManager_1.eventManager.on(pluginActions_1.SHOW_SELECT_FOLDER_DIALOG, this.handleShowSelectFolderDialog);
        eventManager_1.eventManager.on(pluginActions_1.SHOW_TRANSFER_MANAGER, this.handleShowTransferManagerWindow);
        eventManager_1.eventManager.on(pluginActions_1.START_HTTPGATEWAY_DOWNLOAD, this.handleStartHttpGatewayDownload);
        eventManager_1.eventManager.on(pluginActions_1.START_HTTPGATEWAY_UPLOAD, this.handleStartHttpGatewayUpload);
        eventManager_1.eventManager.on(pluginActions_1.START_TRANSFER, this.handleStartTransfer);
        eventManager_1.eventManager.on(pluginActions_1.GET_ALL_TRANSFERS, this.handleGetAllTransfers);
        eventManager_1.eventManager.on(pluginActions_1.RESUME_TRANSFER, this.handleResumeTransfer);
        eventManager_1.eventManager.on(pluginActions_1.START, this.handleStartAspera);
        eventManager_1.eventManager.on(pluginActions_1.STOP, this.handleStopAspera);
        eventManager_1.eventManager.on(pluginActions_1.STOP_TRANSFER, this.handleStopTransfer);
        eventManager_1.eventManager.on(pluginActions_1.SHOW_DIRECTORY, this.handleShowDirectory);
        this.asperaWeb.addEventListener(connect_sdk_js_1.Connect.EVENT.STATUS, function (eventType, data) {
            _this.props.onStatus(data);
            log_1.default.debug("ASPERA CONNECT STATUS: " + data);
            if (eventType === connect_sdk_js_1.Connect.EVENT.STATUS && data === connect_sdk_js_1.Connect.STATUS.RUNNING) {
                _this.props.onHideAsperaInstall();
                setTimeout(function () {
                    _this.getVersion();
                }, 500);
                _this.asperaWeb.addEventListener(connect_sdk_js_1.Connect.EVENT.TRANSFER, function (eventTypeTransfer, dataTransfer) { return _this.updateTransfers(dataTransfer); });
            }
            if ((eventType === connect_sdk_js_1.Connect.EVENT.STATUS && data === connect_sdk_js_1.Connect.STATUS.FAILED) ||
                (eventType === connect_sdk_js_1.Connect.EVENT.STATUS && data === connect_sdk_js_1.Connect.STATUS.EXTENSION_INSTALL) ||
                (eventType === connect_sdk_js_1.Connect.EVENT.STATUS && data === connect_sdk_js_1.Connect.STATUS.OUTDATED)) {
                setTimeout(function () {
                    _this.checkExtension();
                }, 500);
            }
        });
        // Only initialize Aspera Connect on desktop devices
        if (!react_device_detect_1.isMobile) {
            this.asperaWeb.initSession(this.props.appId);
            setTimeout(function () {
                _this.getVersion();
                setTimeout(function () {
                    var connectId = (localStorage && ('function' === typeof localStorage.getItem)) ? localStorage.getItem(constants_1.ASPERA_CONNECT_APP_ID) : '';
                    var newAsperaVersion = (_this.props.asperaVersion !== _this.state.connectVersion &&
                        _this.state.connectVersion !== constants_1.NOT_APPLICABLE &&
                        _this.state.connectVersion !== ''); // Has user's Aspera Version changed since previous login?
                    if (connectId !== _this.props.appId || newAsperaVersion) {
                        _this.props.onStoreAsperaConnectId((connectId) ? connectId : '', (newAsperaVersion) ? _this.state.connectVersion : _this.props.asperaVersion);
                    }
                }, 2000);
            }, 500);
        }
        else {
            this.props.onStatus(connect_sdk_js_1.Connect.STATUS.FAILED);
            this.startPluginless(false, false);
        }
        void this.setupHttpGateway();
    };
    AsperaPlugin.prototype.componentWillUnmount = function () {
        this.asperaWeb.removeEventListener(connect_sdk_js_1.Connect.EVENT.STATUS);
        this.asperaWeb.removeEventListener(connect_sdk_js_1.Connect.EVENT.TRANSFER);
        if (!react_device_detect_1.isMobile) {
            this.asperaWeb.stop();
        }
        this.asperaInstaller.dismiss();
        eventManager_1.eventManager.removeAllListeners();
        this.shutdownHttpGateway();
    };
    /* Utility Functions - end */
    /* Component Methods - end */
    AsperaPlugin.prototype.render = function () {
        return null;
    };
    return AsperaPlugin;
}(react_1.Component));
exports.AsperaPlugin = AsperaPlugin;
var mapStateToProps = function (state) {
    var _a;
    return {
        appId: state.auth.userInfo ? state.auth.userInfo.appId : '',
        asperaVersion: ((_a = state.auth.userInfo) === null || _a === void 0 ? void 0 : _a.asperaVersion) ? state.auth.userInfo.asperaVersion : '',
        gatewayHost: state.auth.userInfo ? state.auth.userInfo.gatewayHost : [],
        isUploadDragActive: state.ui.isUploadDragActive,
        userEmail: state.auth.userInfo ? state.auth.userInfo.userEmail : undefined
    };
};
var mapDispatchToProps = {
    onArchiveKnownPackage: actions_1.archivePackageByPackage,
    onArchivePackage: actions_1.archivePackage,
    onAddToast: actions_5.addToast,
    onDisplayAsperaInstall: actions_4.showAsperaInstallActionCreator,
    onDisplayAsperaVersionBanner: actions_4.showAsperaVersionBannerActionCreator,
    onDragStatusChange: actions_5.setIsDragActive,
    onGatewayTransferCompleted: actions_4.gatewayTransferCompleted,
    onGatewayTransferFailed: actions_4.gatewayTransferFailed,
    onGatewayTransferReject: actions_4.gatewayTransferReject,
    onGatewayTransferStarted: actions_4.gatewayTransferStarted,
    onGetHttpTransfers: actions_3.refreshPendingTransfers,
    onHideAsperaInstall: actions_4.hideAsperaInstall,
    onHideAsperaVersionBanner: actions_4.hideAsperaVersionBanner,
    onHttpGatewayStatus: actions_4.setHttpGatewayStatus,
    onSelect: actions_4.selectFiles,
    onSetVersion: actions_4.setConnectVersion,
    onStatus: actions_4.pluginEvent,
    onStoreAsperaConnectId: actions_6.storeAsperaConnectId,
    onStoreTransfer: actions_4.storeTransfer,
    onTransferCompleted: actions_4.connectTransferCompleted,
    onTransferReject: actions_4.connectTransferReject,
    onTransferStarted: actions_4.connectTransferStarted,
    onUpdateFileTransfer: actions_2.updateFileTransfer,
    onUpdateTransfer: actions_4.updateTransfer,
    onUploadSuccess: actions_4.connectUploadSuccess
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(AsperaPlugin);
